/*
 * @FilePath     : /es-package/packages/es-mpx-creator/lib/common.js
 * @Author       : LiYang
 * @Date         : 2021-09-01 14:17:36
 * @LastEditTime : 2022-01-27 15:28:54
 * @LastEditors  : Please set LastEditors
 * @Description  : 处理通用creator
 */
import { curry, pipe, when } from '@didi/es-mpx-shared'
import mixin from './mixin'

export function mapKeys (source, target, map) {
  return Object.keys(source).reduce((init, key) => {
    const prop = map[key] ? map[key] : key
    init[prop] = source[key]
    return init
  }, target)
}

export function life(type, lifetimes) {
  return Object.keys(lifetimes).reduce((pre, life) => {
    pre[life] = typeof lifetimes[life] === 'string' 
      ? lifetimes[life] 
      : lifetimes[life][type]
    return pre;
  }, {})
}

export function transform (target) {
  return  mapKeys(target, {}, life(target.type, {
    created: {
      page: 'onLoad',
      component: 'attached'
    },
    mounted: {
      page: 'onReady',
      component: 'ready'
    },
    destroyed: {
      page: 'onUnload',
      component: 'detached'  
    },
    activated: 'onShow',
    deactivated: 'onHide',
    beforeCreate: 'created',
    classes: 'externalClasses',
    props: 'properties',
  }))
}

export function extend (target) {
  target.options = {
    multipleSlots: true,
    ...target.options
  }

  target.externalClasses = target.externalClasses || [];
  target.externalClasses.push('custom-class');
  (target.mixins || (target.mixins = [])).push(mixin);
  return target
}

export function hasMixins (target) {
  return target.mixins && !!target.mixins.length
}

export function extendMixins (target) {
  target.mixins = target.mixins.map(mixin => transform(
    Object.assign(mixin, {type: target.type})
  ))
  return target
}

export function isComponents(target) {
  return target.type === 'component' && __mpx_mode__ !== 'web'
}

function relation(type, path) {
  const map = {
    ancestor: {
      key: "$parent",
      get() {
        return this.getRelationNodes(path)[0] || null
      }
    },
    descendant: {
      key: "$children",
      get() {
        return this.getRelationNodes(path) || []
      }
    }
  }
  return map[type]
}

export function createRelations(target) {
  const { parent, child } = target;
  const type = parent ? 'ancestor' : child ? 'descendant' : '';
  let path = parent || child;

  if ((!parent && !child) || !type) {
    return target
  }
  
  target.relations = {[path]: { type }};

  (
    target.mixins 
    || ( target.mixins = [] )
  ).push({
    data: {
      "$parent": null,
      "$children": []
    },
    mounted() {
      if (this.$parent && this.$children) {
        return
      }
      const {key, get} = relation(type, path)
      this[key] = get.call(this)
    }
  });
  
  return target
}

export const getOption = pipe(
  when(isComponents, createRelations),
  transform,
  when(hasMixins, extendMixins),
  extend 
)

export default curry(3, (creator, type, option) => creator(
  getOption(Object.assign(option, {type}))
))